import { render } from "./RegisterForm.vue?vue&type=template&id=98a41fae&scoped=true"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"

import "./RegisterForm.vue?vue&type=style&index=0&id=98a41fae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98a41fae"]])

export default __exports__